import { TierDto } from '../dtos/organizationSearchDto.interface';

export class UpdateOrganizationTierDto {
    id: string;
    tier: TierDto;
}
